import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalStateService {
  private key = 'isTranslate';

  constructor() {}

  // obtener el valor (si no existe, devuelve false)
  getIsTranslate(): boolean {
    const value = localStorage.getItem(this.key);
    return value === 'true';
  }

  // actualizar el valor
  setIsTranslate(value: boolean): void {
    localStorage.setItem(this.key, String(value));
  }
}
